/* Belt-and-braces fix for the header drawer (burger) icon colour.
   Several rounds of pure-CSS fixes for this checked out correctly against the
   theme's own source and in an isolated browser test, but the icon still
   rendered dark on the live site — meaning something in Shopify's actual
   cascade/bundling isn't matching what the source implies. Rather than keep
   guessing blind, this sets the icon's colour directly via inline style,
   which beats any stylesheet rule that isn't !important, and keeps it in
   sync with the header's real transparent/sticky state on every change. */
(function () {
  if (window.__parformBurgerFix) return;
  window.__parformBurgerFix = true;

  function paint() {
    var header = document.getElementById('header-component');
    if (!header) return;
    var icon = header.querySelector('.header__icon--summary');
    if (!icon) return;

    var isSticky = header.getAttribute('data-sticky-state') === 'active';
    var isTransparent = header.hasAttribute('transparent');
    var wantLight = isTransparent && !isSticky;

    var color;
    if (wantLight) {
      var cs = getComputedStyle(header).getPropertyValue('--color-transparent-text').trim();
      color = cs || '#F5F4F0';
    } else {
      color = '#101312';
    }

    icon.style.setProperty('color', color, 'important');
    var nodes = icon.querySelectorAll('svg, svg *');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.setProperty('color', color, 'important');
      nodes[i].style.setProperty('stroke', color, 'important');
    }
  }

  function init() {
    paint();
    var header = document.getElementById('header-component');
    if (header && window.MutationObserver) {
      new MutationObserver(paint).observe(header, {
        attributes: true,
        attributeFilter: ['data-sticky-state', 'transparent'],
      });
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { ticking = false; paint(); });
      }
    }, { passive: true });
    window.addEventListener('resize', paint, { passive: true });
    window.addEventListener('load', paint);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
